/**
 * StorageBridge — registers window.Connext and window.CnnXt with the full public API.
 * Mirrors ConneXt v2's CommonLayer + CommonStorageModel architecture.
 *
 * Usage:
 *   window.Connext.GetVersionInfo()
 *   window.Connext.Storage.GetCurrentConversation()
 *   window.Connext.Storage.GetUserState()
 *   window.CnnXt.Storage.GetCurrentConversationViewCount()
 */
import { PublicLayer } from './PublicLayer';
import { updateCachedConversationData } from './PublicStorageModel';
/**
 * Call this after paywall response to cache conversation metadata
 * that public API consumers (g2insights, client scripts) will need.
 */
export function setCurrentConversationData(data) {
    updateCachedConversationData(data);
}
/**
 * Registers window.Connext and window.CnnXt with full public API.
 * Should be called early in the SDK lifecycle (before g2insights fires click handlers).
 */
export function registerStorageBridge() {
    const publicLayer = new PublicLayer();
    // window.Connext
    if (!window.Connext) {
        window.Connext = publicLayer;
    }
    else {
        // Preserve any existing properties (e.g., event callbacks set before SDK loads)
        Object.assign(window.Connext, publicLayer);
        if (!window.Connext.Storage) {
            window.Connext.Storage = publicLayer.Storage;
        }
    }
    // window.CnnXt (legacy alias used by older g2insights builds)
    if (!window.CnnXt) {
        window.CnnXt = publicLayer;
    }
    else {
        Object.assign(window.CnnXt, publicLayer);
        if (!window.CnnXt.Storage) {
            window.CnnXt.Storage = publicLayer.Storage;
        }
    }
}
